export const IMG_SIZE = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    BACKGROUND: 'background',
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
}
export const PROVIDER_DATA = {
    ID: 'id',
    CODE: 'code',
    NAME: 'name',
}

export const CONTENTATTRIBUTES_DATA = {
    DURATION: 'duration',
    PUBLISHYEAR: 'publishYear',
    HASTRAILER: 'hasTrailer',
    MARKETINGTYPE: 'marketingType',
}